"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export const ADMIN_NOT_FOUND = BASE.child("/*", NotFound);
